import React, { useState, useEffect, useRef } from 'react'
import styles from './assemblies-principal.module.css'
import './assemblies-principal.view.css'

import { ButtonAddHLPure, SearchBarHLPure, FilterHLPure, GridSelectionHLPure, DialogYesNoHLPure, LabelModalPure, Traslates, FormDatePicker, DropDownBtnHLPure, ButtonHLPure } from '../../pures'
import { AssembliesService, LocalStorageService } from '../../../services'
import { ArrowBtnMobile } from '../../../assets/logos/icons'
import { Tooltip } from '@progress/kendo-react-tooltip'
import { convertToStandarDate } from '../../../utils'
import { Popup } from '@progress/kendo-react-popup'
import { useMediaQuery } from '@material-ui/core'
import moment from 'moment'

const HeaderColumns = (props) => {
    return <span className={(props.title === props.t('assembliesPrincipalView.grid.title.1')) ? 'grid-header-one' : 'grid-headers'}>{props.title}</span>
}

const CellColumnName = (props) => {
    return (
        <td>
            <div className='grid-cell-double-container-margin-left'>
                <p className='grid-cell-titles'>{props.dataItem.name}</p>
                <p className='grid-cell-subtitles'>{props.dataItem.email}</p>
            </div>
        </td>
    )
}

const CellColumnDate = (props) => {
    return (
        <td>
            <div>
                <p className='grid-cell-subtitles'>{props.dataItem.dateFormatted}</p>
            </div>
        </td>
    )
}

const CellColumnStatus = (props) => {
    return (
        <td>
            <div>
                <p className='grid-cell-subtitles'>{props.dataItem.status}</p>
            </div>
        </td>
    )
}

const CellColumnBtns = (props) => {
    return (
        <td>
            <div className='grid-btn-div'>
                <button className='grid-btn-action' onClick={() => props.handleChangePage('detail', props.t('assembliesAction.header.title.detail'), props.dataItem)}>
                    <p>{props.t('assembliesPrincipalView.grid.btns.detail')}</p>
                </button>
                {props.dataItem?.workflowExecution?.workflowStatusCurrent <= +process.env.REACT_APP_WORKFLOW_ASSEMBLIES_316130 &&
                    <Tooltip
                        openDelay={600}
                        position='top'
                        anchorElement='target'
                        tooltipClassName='tooltipGeneralStyle'
                    >
                        <button
                            className='cellActions-TrashBtn'
                            onClick={() => {
                                props.setAssemblySelected(props.dataItem)
                                props.setOpenDialog(true)
                            }}
                        >
                            <i
                                className='k-icon k-i-delete k-i-trash'
                            ></i>
                        </button>
                    </Tooltip>
                }
            </div>
            <div className='grid-btn-arrow' onClick={() => props.handleChangePage('detail', props.t('assembliesAction.header.title.detail'), props.dataItem)}>
                <img alt='assemblies-arrow' src={ArrowBtnMobile} />
            </div >
        </td >
    )
}

const AssembliesPrincipalView = (props) => {

    let {
        t,
        assemblies,
        companies: companiesProps,
        statusFilter,
        changePage,
        setAssemblySelected,
        setAssemblies
    } = props

    const is820 = useMediaQuery('(max-width:820px)')
    const is620 = useMediaQuery('(max-width:620px)')
    const is560 = useMediaQuery('(max-width:560px)')

    const token = LocalStorageService.retrieveItem('token').idToken

    const [openDialog, setOpenDialog] = useState(false)
    const anchor = useRef()
    const [showPopup, setShowPoup] = useState(false)
    const [assembliesGrid, setAssembliesGrid] = useState([])
    const [companies, setCompanies] = useState([])
    const [allStatus, setAllStatus] = useState([])
    const [dataItem, setDataItem] = useState({})
    const [search, setSearch] = useState('')
    const [filter, setFilter] = useState(t('assembliesAction.status.all'))
    const [filters, setFilters] = useState({
        initialDate: new Date(),
        limitDate: new Date(),
        companyId: companiesProps[0]?.id
    })

    const handlePopup = () => setShowPoup(!showPopup)

    const deleteAssembly = async () => {
        setOpenDialog(false)
        props.toggleLoadingRequesting(true)
        const updatedWorkflow = await AssembliesService.deleteAssembly({
            assemblyId: dataItem.id,
            workflowExecutionId: dataItem.workflowExecution.id,
            status: 'defined',
            statusUpdate: 316299
        }, token)
        if (updatedWorkflow.statusCode === 200) {
            props.toggleLoadingRequesting(false)
            props.toggleCompletedRequesting(3000)
            setTimeout(async () => {
                await props.getAssemblies()
            }, 3000)
        }
    }

    const filterAssemblies = async () => {
        setShowPoup(false)
        props.toggleLoadingRequesting(true)
        let initialDate = moment(filters.initialDate).format('yyyy-MM-DD')
        let finalDate = moment(filters.limitDate).format('yyyy-MM-DD')
        const { timezone, token, language } = LocalStorageService.retrieveItems(['timezone', 'token', 'language'])
        let { data: assemblies } = await AssembliesService.getAssemblies(timezone, token.idToken, filters.companyId, initialDate, finalDate)
        assemblies = assemblies.map(assembly => {
            let convertDate = convertToStandarDate(assembly.date, language)
            assembly.dateFormatted = convertDate
            return assembly
        })
        if (filter !== t('assembliesAction.status.all')) assemblies = assemblies.filter(assembly => assembly.status.toLowerCase().includes(filter.toLowerCase()))
        if (search) assemblies = assemblies.filter(assembly => assembly.name.toLowerCase().includes(search.toLowerCase()))
        setAssemblies(assemblies)
        props.toggleLoadingRequesting(false)
    }

    let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
    let CellColumnOne = (props) => <CellColumnName {...props} t={t} />
    let CellColumnTwo = (props) => <CellColumnDate {...props} t={t} />
    let CellColumnThree = (props) => <CellColumnStatus {...props} t={t} />
    let CellColumnFour = (props) => <CellColumnBtns {...props} t={t} setAssemblySelected={setDataItem} setOpenDialog={setOpenDialog} handleChangePage={handleChangePage} />

    let widthCellOne = '120px'
    let widthCellTwo = '50px'
    let widthCellThree = '50px'
    let widthCellFour = '50px'

    if (is820) {
        widthCellTwo = '70px'
    }

    if (is620) {
        widthCellOne = '90px'
    }

    if (is560) {
        widthCellOne = '120px'
        widthCellFour = '30px'
    }

    useEffect(() => {
        let copyAssemblies = [...assemblies]
        let newAssemblies = []
        if (filter === t('assembliesAction.status.all')) {
            newAssemblies = copyAssemblies.filter(assembly => assembly.name.toLowerCase().indexOf(search.toLowerCase()) >= 0)
        } else {
            newAssemblies = copyAssemblies.filter(assembly =>
                assembly.name.toLowerCase().indexOf(search.toLowerCase()) >= 0 &&
                assembly.status.toLowerCase().indexOf(filter.toLowerCase()) >= 0
            )
        }

        setAssembliesGrid(newAssemblies)

    }, [search, filter])

    useEffect(() => {
        if (!assemblies || assemblies.length === 0) return
        setAssembliesGrid(assemblies)
    }, [assemblies])

    useEffect(() => {
        if (!companiesProps || companiesProps.length === 0) return
        setCompanies(companiesProps)
    }, [companiesProps])

    useEffect(() => {
        if (!statusFilter || statusFilter.length === 0) return
        setAllStatus(statusFilter)
    }, [statusFilter])

    const onChangeSearch = (e) => {
        let value = e.target.value
        setSearch(value)
    }

    const onChangeFilter = (e) => {
        let value = e.target.value
        setFilter(value)
    }

    const handleChangePage = (nameComponent, titleHeader, assembly) => {
        if (assembly) setAssemblySelected(assembly)
        changePage(nameComponent, titleHeader)
    }

    return (
        <div className='assembliesPrincipalView-container'>
            <div className='assembliesPrincipalView-filters'>
                <ButtonAddHLPure
                    nameBtn={t('assembliesPrincipalView.btns.add.assembly')}
                    iconAdd
                    onClickBtn={() => handleChangePage('add', t('assembliesAction.header.title.add'), null)}
                />
                <div className='assembliesPrincipalView-search-container'>
                    <div className='assembliesPrincipalView-search'>
                        <SearchBarHLPure
                            placeholder={t('assembliesPrincipalView.placeholders.search.assembly')}
                            onSearchChange={(e) => onChangeSearch(e)}
                            searchValue={search}
                            fullWidth
                        />
                    </div>
                    <button className='digitalContractHomeView-btn-open-popup' ref={anchor} onClick={() => handlePopup()}>
                        <span class='k-icon k-font-icon k-i-arrow-overflow-down'></span>
                    </button>
                    <Popup
                        anchor={anchor.current}
                        show={showPopup}
                        className={styles['popup-container-class']}
                        anchorAlign={{ horizontal: 'right', vertical: 'bottom', }}
                        popupAlign={{ horizontal: 'right', vertical: 'top', }}
                    >
                        <div className={styles['assembliesPrincipalView-popup-container']}>
                            <div className='digitalContractHomeView-popup-inputs-container'>
                                <div className='digitalContractHomeView-dates-container'>
                                    <div className='digitalContractHomeView-start-date-container'>
                                        <span className='digitalContractHomeView-start-date'>{t('digitalContractHomeView.start.date')}</span>
                                        <Traslates>
                                            <FormDatePicker
                                                id={'date'}
                                                name={'date'}
                                                format='dd-MMM-yyyy'
                                                value={filters.initialDate}
                                                onChange={(e) => setFilters({ ...filters, initialDate: e.target.value })}
                                            />
                                        </Traslates>
                                    </div>
                                    <div className='digitalContractHomeView-start-date-container'>
                                        <span className='digitalContractHomeView-start-date'>{t('digitalContractHomeView.end.date')}</span>
                                        <Traslates>
                                            <FormDatePicker
                                                id={'date'}
                                                name={'date'}
                                                format='dd-MMM-yyyy'
                                                value={filters.limitDate}
                                                onChange={(e) => setFilters({ ...filters, limitDate: e.target.value })}
                                            />
                                        </Traslates>
                                    </div>
                                </div>
                                <DropDownBtnHLPure
                                    labelDropDown={t('digitalContractHomeView.company')}
                                    optionsDropDown={companies}
                                    optionsValue={filters.companyId}
                                    valueItem={'id'}
                                    nameOption={'companyName'}
                                    onDropDownChange={(e) => setFilters({ ...filters, companyId: e.target.value })}
                                />
                            </div>
                            <div className='digitalContractHomeView-search-btn'>
                                <ButtonHLPure
                                    nameBtn={t('digitalContractHomeView.btn.search')}
                                    primary={true}
                                    onClickBtn={() => filterAssemblies()}
                                />
                            </div>
                        </div>
                    </Popup>
                </div>
                <FilterHLPure
                    labelFilter={''}
                    options={allStatus}
                    nameOption='name'
                    valueItem={'name'}
                    defaultValue={1}
                    optionsValue={t('assembliesAction.status.all')}
                    onFilterChange={(e) => onChangeFilter(e)}
                />
            </div>
            <div className='assembliesPrincipalView-grid'>
                <GridSelectionHLPure
                    skip={0}
                    take={6}
                    dataGrid={assembliesGrid}

                    columnOne
                    titleRow1={t('assembliesPrincipalView.grid.title.1')}
                    cellColumnOne={CellColumnOne}
                    headerColumnOne={AllHeadersColumns}
                    widthColumnOne={widthCellOne}
                    minResizableWidth1={'auto'}

                    columnTwo={(is560) ? false : true}
                    titleRow2={t('assembliesPrincipalView.grid.title.2')}
                    cellColumnTwo={CellColumnTwo}
                    headerColumnTwo={AllHeadersColumns}
                    widthColumnTwo={widthCellTwo}
                    minResizableWidth2={widthCellTwo}

                    columnThree={(is820) ? false : true}
                    titleRow3={t('assembliesPrincipalView.grid.title.3')}
                    cellColumnThree={CellColumnThree}
                    headerColumnThree={AllHeadersColumns}
                    widthColumnThree={widthCellThree}
                    minResizableWidth3={widthCellThree}

                    columnFour
                    titleRow4={t('assembliesPrincipalView.grid.title.4')}
                    cellColumnFour={CellColumnFour}
                    headerColumnFour={AllHeadersColumns}
                    widthColumnFour={widthCellFour}
                    minResizableWidth4={widthCellFour}
                />
            </div>
            {openDialog &&
                <DialogYesNoHLPure
                    titleDialog={t('assembliesMainView.deleteModal.title')}
                    textBtnCancel={t('button.cancel')}
                    cancel={() => setOpenDialog(false)}
                    saveBtn={t('button.delete')}
                    handleSubmit={deleteAssembly}
                >
                    <LabelModalPure label={`${t('assembliesMainView.deleteModal.content')} ${dataItem.name}`} />
                </DialogYesNoHLPure>
            }
        </div>
    )
}

export { AssembliesPrincipalView as default }